var map = {
	"./music-instructions.json": 4462,
	"./music-library-intro2024.json": 4463,
	"./music-library-launch2024.json": 4464,
	"./music-progression.json": 4465,
	"./startSourcesAdvanced.json": 4466,
	"./startSourcesSimple.json": 4467,
	"./startSourcesSimple2.json": 4468,
	"./startSourcesTracks.json": 4469
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4241;